import React, { useContext, useEffect } from 'react';
import { ModalDialog, Dialog } from '../dialog/index.js';
import { LtiResourceContext } from './context/LtiResourceContext.js';
import styles from './LtiModal.module.css.js';
import { LtiViewer } from '../lti-viewer/index.js';

// This modal can be used for multiple Lti features: deep linking, lti resource link launch,...
function LtiModal({ iframeTitle, loginUrl, closeTitle, headerElement, onClose, tokenAccessor, id = 'lti-modal', studioGroup, showCloseButton = true, closeViaEscape = true, closeOnClickOutside = true, }) {
    const [, setLtiResource] = useContext(LtiResourceContext);
    useEffect(() => {
        const handlePostMessage = (e) => {
            if (e.data.messageType !== 'LTI')
                return;
            setLtiResource(e.data.parameters.jwt);
            onClose();
        };
        addEventListener('message', handlePostMessage);
        return () => removeEventListener('message', handlePostMessage);
    }, [onClose, setLtiResource]);
    return (React.createElement(ModalDialog, { id: id, closeTitle: closeTitle, onClose: onClose, closeViaEscape: closeViaEscape, closeOnClickOutside: closeOnClickOutside, fullScreen: true, className: 'lti-modal', showCloseButton: showCloseButton },
        headerElement && headerElement,
        React.createElement(Dialog.Body, { "data-testid": 'lti-modal-body', className: styles.body },
            React.createElement(LtiViewer, { iframeTitle: iframeTitle, loginUrl: loginUrl, studioGroup: studioGroup, tokenAccessor: tokenAccessor }))));
}

export { LtiModal };
